enum InvoiceTypeEnum {
    DIRECT = 'DIRECT',
}

export default InvoiceTypeEnum;
